import { createSelector } from '@reduxjs/toolkit'

import { identity } from '../helpers/fp'
import { getTaxReturnDeductions } from './tax-return'

const pluckType = (_state, { type }) => type

const getDeductionSummary = (state) => state.deductionSummary
const getPotentialDeductionsSlice = (state) => state.taxReturnPotentialDeductions
const getPotentialDeductionsItems = (state) => getPotentialDeductionsSlice(state).items

export const getDeductionByType = createSelector([getTaxReturnDeductions, pluckType], (deductions, type) =>
    deductions.find((deduction) => deduction.type === type)
)

export const getTaxReturnPotentialDeductions = createSelector([getPotentialDeductionsSlice], identity)

export default createSelector(
    [getDeductionSummary, getPotentialDeductionsItems, getTaxReturnDeductions],
    (deductionSummary, pontentialDeductions, taxReturnDeductions) => {
        const areAllDeductionsReviewed = pontentialDeductions.every(({ type: potentialDeductionType }) =>
            taxReturnDeductions.some(
                ({ type: taxReturnDeductionType }) => potentialDeductionType === taxReturnDeductionType
            )
        )

        return {
            areAllDeductionsReviewed,
            deductionSummary,
            deductionSummaryStatus: deductionSummary.status,
            pontentialDeductions,
        }
    }
)
